"use strict";

exports.__esModule = true;
exports.transitionParser = exports.transition = void 0;

var _core = require("../core");

var config = {
  transition: true,
  transitionDuration: {
    property: "transitionDuration",
    scale: "transition.duration"
  },
  transitionProperty: {
    property: "transitionProperty",
    scale: "transition.property"
  },
  transitionTimingFunction: {
    property: "transitionTimingFunction",
    scale: "transition.easing"
  }
};
var transition = (0, _core.system)(config);
exports.transition = transition;
var transitionParser = (0, _core.createParser)(config);
exports.transitionParser = transitionParser;
//# sourceMappingURL=transition.js.map